import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="py-16 md:py-24 px-6 max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="flex items-end justify-between mb-12">
        <div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            每日新鲜内容，追更不等待
          </p>
        </div>
        <Link
          to="/category/action"
          className="text-sm text-primary-400 hover:text-primary-300 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          查看更多
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {latestUpdates.map((comic) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.slug}`}
            className="group relative rounded-lg overflow-hidden bg-background-100 cursor-pointer"
          >
            {/* Cover Image */}
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src={comic.coverImage}
                alt={comic.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              {/* Status Badge */}
              <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-background-950/80 backdrop-blur-sm text-xs font-medium text-foreground-50 whitespace-nowrap">
                {comic.status === '连载中' ? `更新至${comic.latestChapter}话` : '已完结'}
              </div>
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>

            {/* Info */}
            <div className="p-3 md:p-4">
              <h3 className="text-sm md:text-base font-bold text-foreground-50 truncate">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {comic.status === '连载中'
                  ? `更新至${comic.latestChapter}话`
                  : '已完结'}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}